import { translateOne } from './translateOne';

/**
 * Devuelve la cadena traducida y interpolada si tiene variables el fallback.
 *
 * @param {Object} state
 * @param {string|Object} key la clave de la cadena, o un objeto {key: params} ej. { "global.min": { min: 2 } }
 * @param {Object} [params] el objeto con los valores de las variables a interpolar
 * @param {string} [defaultValue] el valor por defecto si "Error not found" sino especificado, devuelve el `key` buscado
 * @returns {Object<string, string>} objeto {key: tradución}, ej. {'global.ok': "Acceptar"}
 */

export function translateFallback(state, key, params, defaultValue) {
  // Por cada uno de los fallback los recorremos para encontrar la variable traducida.
  // for (let i = 0; i < state.fallback.length; i++) {
  for (const fallback of state?.fallback ?? []) {
    const dictionary = state.dictionary[fallback];
    const keyValue = translateOne(dictionary, key, params, defaultValue);

    if (keyValue?.[key]) {
      /**
       * Si encontramos traducción, la devolvemos en seguida
       */
      return keyValue;
    }
  }

  /**
   * No se encontro traducción,
   * o simplement, no hay fallback,
   * se devuelve undefined y no el objeto vacio { key: undefined }
   */
}
